module.exports = __webpack_public_path__ + "img/top-b-back4.28f06dce.png";